<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <Button
        type="primary"
        icon="md-add"
        @click="editItem()"
      >
        添加
      </Button>
      <i-input
        v-model="params.search"
        placeholder="请输入搜索关键字"
        style="width: 180px"
        @on-enter="doSearch"
      />
      <Ajaxbtn
        ref="searchBtn"
        :url="query_item_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <!--        <div v-html="delta_html"></div>-->

    <Table
      size="small"
      :columns="item_columns"
      :data="items"
      :loading="loading"
    />

    <Editor
      ref="editor"
      @on-change="updateItem"
    />
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/stock_online/item">
  import BaseItem from '../mixins/base_item';
  import Editor from './components/editor';
  import UserFlowBase from '../components/flow/user_flow_base';
  import ViewerItem from '../components/viewer/item';
  import Util from './libs/util';
  const Diff = require('jsondiffpatch');
  Diff.formatters.html.hideUnchanged();
  const DiffPatcher = require('jsondiffpatch').create({
    objectHash: function(obj) {
      return obj.id;
    },
    textDiff: {
      // default 60, minimum string length (left and right sides) to use text diff algorythm: google-diff-match-patch
      minLength: 5
    }
  });
  export default {
    /* router_info_start */
    router_info: '/stock_online/item',
    components: { Editor, ViewerItem },
    /* router_info_end */

    mixins: [BaseItem],
    data() {
      return {
        query_item_path: this.$util.api.query_mall_item,
        item_columns: [
          {
            title: '详情',
            align: 'center',
            width: 50,
            render: (h, params) => {
              const online_item = params.row.online_item;
              return h(ViewerItem, {
                props: {
                  type: 'MallOnlineItem',
                  model_id: online_item.id,
                  tip: false
                },
                'class': {
                  link: true
                }
              }, '查看');
            }
          },
          {
            title: '首页标题',
            key: 'formal_title',
            align: 'center',
            render: (h, params) => {
              const online_item = params.row.online_item;
              return h('span', online_item.formal_title);
            }
          },
          {
            title: '详情标题',
            key: 'title',
            align: 'center',
            render: (h, params) => {
              const online_item = params.row.online_item;
              return h('span', online_item.title);
            }
          },
          {
            title: '商品所属团队',
            align: 'center',
            render: (h, params) => {
              const online_item = params.row.online_item;
              return h('div', Util.getChannelName(online_item.channel_id));
            }
          },
          {
            title: '处理方式',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              const action_type = Util.getActionType(row.action);
              if (row.action === 'update') {
                return h('div', [
                  h('div', {
                    'class': {
                      [action_type.color_class]: true
                    }
                  }, action_type.name),
                  h('Button', {
                    props: {
                      size: 'small'
                    }
                  }, '查看更新内容')
                ]);
              } else {
                return h('div', {
                  'class': {
                    [action_type.color_class]: true
                  }
                }, action_type.name);
              }
            }
          },
          {
            title: '审核状态',
            width: 125,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  },
                  on: {
                    update: (user_flow) => {
                      row.user_flow = user_flow;
                    }
                  }
                })
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '操作',
            width: 90,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click:() => {
                    this.editItem(params.row.online_item);
                  }
                }
              }, '编辑');
            }
          }
        ],
        old: {
          "id": 1,
          "mall_item_id": 1,
          "apply_user_id": 202,
          "apply_user": "马良焰",
          "fill_user_id": 202,
          "fill_user": "马良焰",
          "channel_id": 100,
          "title": "《百词斩象形9000》英语单词词汇书 日常 中考 高考 四级 六级 托福 雅思组合套装",
          "formal_title": "《象形9000》单词书",
          "short_name": "象形9000全套",
          "desc": "记单词，不枯燥，词汇量，速破万！",
          "image_small": "/image/items/m/uploads/1569661222697.jpg",
          "image_normal": "/image/items/m/uploads/1569661262745.jpg;/image/items/m/uploads/1569661285082.jpg;/image/items/m/uploads/1569661329278.jpg;/image/items/m/uploads/1569661336568.jpg",
          "description": "<img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/6db628d7c390.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e31de7d154ca.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e73465acad73.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/d679d4aaf0cf.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a5bbdf9a28ed.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/8b722b00e70e.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/2421e387d7d0.jpg\" alt=\"\" /><a href=\"http://mall.baicizhan.com/m/item?id=2002200\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a0d53f2c713b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002201\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/635c64031b68.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002202\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a4cb7685ca7f.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002199\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/339db88b703b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003374\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/34b6a2bd993e.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003372\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/f313369a7cef.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003371\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/872348f82dbf.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003370\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/0d166b3c3e84.jpg\" alt=\"\" /></a>",
          "category_id": 3,
          "item_type": 0,
          "show_type": 0,
          "extra_tag": "非赠品",
          "display_url": "",
          "notify_url": "",
          "jump_url": "",
          "third_md5_key": "",
          "free_postage": false,
          "sale_time": null,
          "auto_refund_deadline": null,
          "extra_info": "{}",
          "status": 1,
          "created_at": "2019-10-12T11:24:19.000+08:00",
          "updated_at": "2019-10-12T11:24:19.000+08:00",
          "mall_online_sub_items": [
            {
              "id": 0,
              "mall_online_item_id": 1,
              "item_id": 0,
              "sub_item_id": 0,
              "title": "12341s24",
              "price": "105.0",
              "inner_name": "ZB00102V1-TXFF",
              "remain": 0,
              "url_image": "/image/items/m/uploads/1489136683902.jpg",
              "extra_info": "{}",
              "status": 1,
              "created_at": "2019-10-12 11:24:19 +0800",
              "updated_at": "2019-10-12 11:24:19 +0800"
            },
            {
              "id": 1,
              "mall_online_item_id": 1,
              "item_id": 0,
              "sub_item_id": 0,
              "title": "1234124",
              "price": "100.0",
              "inner_name": "ZB00102V1-TXFF",
              "remain": 0,
              "url_image": "/image/items/m/uploads/1489136683903.jpg",
              "extra_info": "{}",
              "status": 1,
              "created_at": "2019-10-12 11:24:19 +0800",
              "updated_at": "2019-10-12 11:24:19 +0800"
            },
            {
              "id": 2,
              "mall_online_item_id": 1,
              "item_id": 0,
              "sub_item_id": 0,
              "title": "vsdfga",
              "price": "69.9",
              "inner_name": "ZB00102-TXSB",
              "remain": 0,
              "url_image": "/image/items/m/uploads/1489136683903.jpg",
              "extra_info": "{}",
              "status": 1,
              "created_at": "2019-10-12 11:24:19 +0800",
              "updated_at": "2019-10-12 11:24:19 +0800"
            }
          ]
        },
        new: {
          "id": 1,
          "mall_item_id": 1,
          "apply_user_id": 202,
          "apply_user": "马良焰",
          "fill_user_id": 202,
          "fill_user": "马良焰",
          "channel_id": 200,
          "title": "《百词斩象形9000》英语词汇书 日常 中考 高考 四级 六级 托福 雅思组合套装",
          "formal_title": "《象形9000》单词书",
          "short_name": "象形9000全套",
          "desc": "记单sd词，不枯燥，词汇量，速破万！",
          "image_small": "/image/items/m/uploads/1569661222697.jpg",
          "image_normal": "/image/items/m/uploads/1569661262745.jpg;/image/items/m/uploads/123124235435.jpg;/image/items/m/uploads/1569661329278.jpg;/image/items/m/uploads/1569661336568.jpg",
          "description": "<img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/6db628d7c390.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e31de7d154ca.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e73465acad73.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/d679d4aaf0cf.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a5bbdf9a28ed.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/8b722b00e70e.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/2421e387d7d0.jpg\" alt=\"\" /><a href=\"http://mall.baicizhan.com/m/item?id=2002200\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a0d53f2c713b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002201\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/635c64031b68.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002202\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a4cb7685ca7f.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002199\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/339db88b703b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003374\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/34b6a2bd993e.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003372\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/f313369a7cef.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003371\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/872348f82dbf.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003370\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/0d166b3c3e84.jpg\" alt=\"\" /></a>",
          "category_id": 3,
          "item_type": 0,
          "show_type": 0,
          "extra_tag": "非赠品",
          "display_url": "",
          "notify_url": "",
          "jump_url": "",
          "third_md5_key": "",
          "free_postage": false,
          "sale_time": null,
          "auto_refund_deadline": null,
          "extra_info": "{}",
          "status": 1,
          "created_at": "2019-10-12T11:24:19.000+08:00",
          "updated_at": "2019-10-12T11:24:19.000+08:00",
          "mall_online_sub_items": [
            {
              "id": 1,
              "mall_online_item_id": 1,
              "item_id": 0,
              "sub_item_id": 0,
              "title": "12341s24",
              "price": "105.0",
              "inner_name": "ZB00102V1-TXFF",
              "remain": 0,
              "url_image": "/image/items/m/uploads/1489136683902.jpg",
              "extra_info": "{}",
              "status": 1,
              "created_at": "2019-10-12 11:24:19 +0800",
              "updated_at": "2019-10-12 11:24:19 +0800"
            },
            {
              "id": 2,
              "mall_online_item_id": 1,
              "item_id": 0,
              "sub_item_id": 0,
              "title": "vsdfga",
              "price": "79.9",
              "inner_name": "ZB00102-TXSB",
              "remain": 0,
              "url_image": "/image/items/m/uploads/1489136683903.jpg",
              "extra_info": "{}",
              "status": 1,
              "created_at": "2019-10-12 11:24:19 +0800",
              "updated_at": "2019-10-12 11:24:19 +0800"
            },
            {
              "id": 3,
              "mall_online_item_id": 1,
              "item_id": 0,
              "sub_item_id": 0,
              "title": "fasdjh",
              "price": "88.0",
              "inner_name": "ZB00103V1-TXFF",
              "remain": 0,
              "url_image": "/image/items/m/uploads/23152435637.jpg",
              "extra_info": "{}",
              "status": 1,
              "created_at": "2019-10-12 11:24:19 +0800",
              "updated_at": "2019-10-12 11:24:19 +0800"
            },
          ]
        },
        delta: {},
        delta_html: ''
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      this.delta = DiffPatcher.diff(this.old, this.new);
      console.log(this.delta);
      this.delta_html = Diff.formatters.html.format(this.delta, this.old);
      this.delta_html = this.delta_html.replace(/jsondiffpatch-property-name">(\d+)<\/div>/g, (match, d, index) => {
        return match.replace(/\d+/, `子项${parseInt(d) + 1}`);
      });
    },
    mounted() {
      //
    },
    methods: {
      editItem(item) {
        this.$refs.editor.edit(item);
      },
      updateItem(item) {
        this.$util.insertOrUpdateArrayItem(this.items, item, true);
      },
    }
  }
</script>
